import React, { useState, useRef, useEffect } from "react";
import { InputMask } from "primereact/inputmask";
import { Toast } from "primereact/toast";

export default function InputTextCNPJ(props) {
  const [value, setValue] = useState(props.value || "");
  const [error, setError] = useState(false);
  const toast = useRef(null);

  useEffect(() => {
    if (props.setError) {
      props.setError(error);
    }
  }, [error, props.setError]);

  const formatCNPJ = (cnpj) => {
    return cnpj
      .replace(/\D/g, "") // Remove tudo que não for número
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .slice(0, 18); // Garante o tamanho correto
  };

  const validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, ""); // Remove formatação

    if (cnpj.length !== 14) return false;
    if (/^(\d)\1+$/.test(cnpj)) return false; // Evita sequências repetidas

    const calcDigit = (cnpj, factors) => {
      let sum = 0;
      for (let i = 0; i < factors.length; i++) {
        sum += cnpj[i] * factors[i];
      }
      const mod = sum % 11;
      return mod < 2 ? 0 : 11 - mod;
    };

    const factors1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const factors2 = [6, ...factors1];

    const firstDigit = calcDigit(cnpj, factors1);
    const secondDigit = calcDigit(cnpj + firstDigit, factors2);

    return firstDigit == cnpj[12] && secondDigit == cnpj[13];
  };

  const handleChange = (event) => {
    const rawValue = event.target.value.replace(/\D/g, ""); // Apenas números
    const formattedValue = formatCNPJ(rawValue);
    setValue(formattedValue);

    const isValid = rawValue.length === 14 && validateCNPJ(rawValue);
    setError(!isValid);

    if (props.onChange) {
      props.onChange({
        ...event,
        target: { ...event.target, value: formattedValue },
      });
    }
  };

  const handleBlur = () => {
    if (error) {
      toast.current.show({
        severity: "error",
        summary: "CNPJ inválido",
        detail: "O CNPJ informado é inválido! Verifique!",
        life: 3000,
      });
    }
  };

  return (
    <div>
      <InputMask
        mask="99.999.999/9999-99"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        className={`p-inputtext ${error ? "p-invalid" : ""}`}
        {...props}
      />
      {error && (
        <small className="p-error" style={{ display: "block", marginTop: "5px" }}>
          CNPJ inválido
        </small>
      )}
      <Toast ref={toast} />
    </div>
  );
}
